import styled from 'styled-components';
import { Flex } from 'UI';

export const GalleryContainer = styled.div<{ $expanded?: boolean }>`
  position: relative;
  width: 100%;
  min-width: 0;
  overflow: visible;

  @media (max-width: ${({ theme }) => theme.breakpoint.md}px) {
    min-width: 0;
  }
`;

export const GalleryViewport = styled.div<{ $expanded?: boolean }>`
  position: relative;
  width: 100%;
  min-height: ${({ $expanded }) => ($expanded ? '560px' : '450px')};
  background-color: ${({ theme }) => theme.color.grey100};
  overflow: hidden;
`;

export const GallerySlide = styled(Flex)<{ $hasBackground?: boolean; $expanded?: boolean; $hasAssets?: boolean }>`
  position: relative;
  min-height: ${({ $expanded }) => ($expanded ? '560px' : '450px')};
  background-color: ${({ $hasBackground, theme, $hasAssets }) => {
    if (!$hasAssets) {
      return theme.color.shadow_7;
    }
    return $hasBackground ? theme.color.grey90_light_130 : theme.color.grey100;
  }};
`;

export const ImageZoomTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  border: none;
  background: transparent;
  padding: 0;
  cursor: zoom-in;
  :hover {
    cursor: zoom-in;
  }
`;

export const BrandContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
`;

export const PromotionContainer = styled.div`
  position: absolute;
  right: 2px;
  top: -22px;
  z-index: 3;
`;

export const ZoomButton = styled.button`
  position: absolute;
  right: 18px;
  bottom: 18px;
  z-index: 3;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 50%;
  background: ${({ theme }) => theme.color.white};
  box-shadow: 0 2px 8px ${({ theme }) => theme.color.shadow_5};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const ThumbnailRow = styled(Flex)<{ $vertical?: boolean }>`
  gap: 14px;
  margin-top: ${({ $vertical }) => ($vertical ? '28px' : '18px')};
  flex-wrap: wrap;
  max-height: ${({ $vertical }) => ($vertical ? '220px' : 'none')};
  overflow: auto;
`;

export const ThumbnailButton = styled.button<{ $active?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100px;
  height: 100px;
  border: 2px solid ${({ $active, theme }) => ($active ? theme.color.clear_blue : theme.color.grey90)};
  border-radius: 2px;
  background: ${({ theme }) => theme.color.grey95};
  padding: 0;
  cursor: pointer;
  overflow: hidden;

  :hover {
    box-shadow: 0 4px 6px ${({ theme }) => theme.color.shadow_8};
  }
`;

export const ThreeDPlaceholder = styled(Flex)<{ $expanded?: boolean }>`
  width: 100%;
  min-height: ${({ $expanded }) => ($expanded ? '560px' : '450px')};
`;

export const ThreeDViewerContainer = styled.div`
  width: 100%;
  height: 560px;
  min-height: 560px;
`;

export const DiscontinuedOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 2;
`;

export const DiscontinuedText = styled.span`
  transform: rotate(-45deg);
  font-size: 64px;
  font-weight: bold;
  color: ${({ theme }) => theme.color.red};
  opacity: 0.6;
  white-space: nowrap;
  user-select: none;
`;
